import "core-js/modules/es.array.every.js";
import "core-js/modules/es.object.to-string.js";
import isPropValid from '@emotion/is-prop-valid';
export var exceptStyledProps = function exceptStyledProps() {
  for (var _len = arguments.length, exceptedProps = new Array(_len), _key = 0; _key < _len; _key++) {
    exceptedProps[_key] = arguments[_key];
  }
  return {
    shouldForwardProp: function shouldForwardProp(prop) {
      return isPropValid(prop) && exceptedProps.every(function (exceptedProp) {
        return exceptedProp !== prop;
      });
    }
  };
};
//# sourceMappingURL=exceptStyledProps.js.map